import React from "react";
import styled from "styled-components";

const InfoCardStyled = styled.div`
    width: 100%;
    //height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const Section = styled.div`
  margin-top: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
`;

const SectionTitle = styled.h2`
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 1.2em;
`;

const SectionContentRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: .8em;
    padding-top: .8em;
`;

const SectionText = styled.p`
  font-size: 1.2em;
  margin-bottom: 10px;
`;

class InfoCard extends React.Component {
    render() {
        return (
            <InfoCardStyled>
                <Section>
                    <SectionTitle>Цель</SectionTitle>
                    <SectionText>
                    Ищу работу в качестве Fullstack-разработчика в команде, где я смогу развиваться и расти.
                    </SectionText>
                </Section>
                <Section>
                    <SectionTitle>Образование</SectionTitle>
                    <SectionText>
                    <ul>
                        <li>
                        2009-2016 - СОШ им. В.И. Чуйкова, Серебряные Пруды
                        </li>
                        <li>
                        2016-2022 - МГТУ им. Н.Э. Баумана, Факультет Специльное Машиностроение, Кафедра: СМ-3, Специальность: Навигационно-баллистическое обеспечение применения космической техники
                        </li>
                    </ul>
                    </SectionText>
                </Section>
                <Section>
                    <SectionTitle>Опыт работы</SectionTitle>
                    <SectionText>
                    Программист в компании "ИТК Поток" с 2022 года
                    <ul>
                        <li>
                        Разработка телефонного бота для компании "ИТК Поток" на языке Python с использованием библиотек: tensorflow, pytorch, gtts, silero и др.
                        </li>
                        <li>
                        Создание сайта-визитки для УК "ИТОЗИС" на React и Node.js
                        </li>
                        <li>
                        Разработка веб-панели для телефонного бота
                        </li>
                    </ul>
                    </SectionText>
                </Section>
                <Section>
                    <SectionTitle style={{
                        marginTop: "2em",
                        marginBottom: "1.2em",
                        textAlign: "center",
                        fontSize: "2em",
                    }}>
                        Навыки
                    </SectionTitle>
                    <SectionContentRow style={{
                        fontSize: "3em"
                    }}>
                        <i class="devicon-python-plain"></i>
                        <i class="devicon-selenium-original"></i> 
                        <i class="devicon-django-plain"></i>
                        <i class="devicon-react-original-wordmark"></i>
                        <i class="devicon-postgresql-plain-wordmark"></i>
                        <i class="devicon-css3-plain"></i>
                        <i class="devicon-html5-plain"></i>
                    </SectionContentRow>
                </Section>
            </InfoCardStyled>
        );
    }
}

export default InfoCard;
